// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 641) return "static/chunks/641.0d5e1b93562b79a2.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"1229":"081f49155ffd5215","3887":"1b28c0bce2fffab3"}[chunkId] + ".js";
};